<template>
  <VanPopup
    :value="show"
    round
    safe-area-inset-bottom
    position="bottom"
    overlay-class="custom-van-popup-overlay"
    class="custom-van-popup"
    @click-overlay="onCancel"
    @close="onCancel"
  >
    <div class="telephone-popup">
      <div class="header">拨打电话</div>
      <div
        v-for="(item, index) in tels"
        :key="index"
        class="item"
        @click="onConfirm(item)"
      >{{ item }}</div>
      <div class="bottom">
        <div class="item " @click="onCancel">取消</div>
      </div>
    </div>
  </VanPopup>
</template>

<script>
export const NAVI_TYPE = {
  AMAP: "1",
  BMAP: "2",
};

export default {
  model: {
    prop: "show",
    event: "cancel",
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    tels: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      NAVI_TYPE,
    };
  },
  methods: {
    onConfirm(telephone) {
      this.$emit("confirm", telephone);
    },
    onCancel() {
      this.$emit("cancel", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.telephone-popup {
  .header {
    width: calc(100% - 40px);
    height: 58px;
    margin-left: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    border-bottom: 1px solid #eeeeee;
  }
  .bottom {
    background: #f3f4f5;
    padding-top: 10px;
    margin-bottom: calc(20px + constant(safe-area-inset-bottom));
    margin-bottom: calc(20px + env(safe-area-inset-bottom));
  }
  .item {
    height: 54px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
  }
}
</style>
